import { ExpenseEntry } from "../models/expense-entry.model";
import { ISPCStore, ISPCStoresAndUser } from "../models/ispc-store.model";
import { User } from "../models/user.model";
import { ISPCStoreStateModel } from "../state/ispc-store.state";

export namespace ISPCStoreActions {
    export class Refresh {
        static readonly type = '[API-ISPCStore] Refresh'
        constructor(public payload: User) {}
    }
    export class Init {
        static readonly type = '[Storage-ISPCStore] Init'
        constructor(public payload: ISPCStoreStateModel) {}
    }
    export class Set {
        static readonly type = '[API-ISPCStore] Set'
        constructor(public payload: ISPCStoresAndUser) {}
    }
    export class Merge {
        static readonly type = '[API-ISPCStore] Merge'
        constructor(public payload: ISPCStoresAndUser) {}
    }
}
